import * as z from "zod";

/**
 * Step 2 of the intent rescue wizard: write the chop subscription billing
 * record + intent flags to the team doc, then mint Redo's umbrella Shopify
 * usage subscription and hand back the confirmation URL for the merchant
 * to approve. After approval, the team is indistinguishable from a
 * sales-onboarded chop subscription customer — same billing engine, same
 * code paths.
 *
 * Throws if the team already has a non-usage Shopify app subscription
 * (creating a new one would replace it).
 */
export const enableIntentRescueBilling = {
  name: "enableIntentRescueBilling" as const,
  input: z.object({}),
  output: z.object({ confirmationUrl: z.string() }),
};
